import { useState, useEffect } from "react";
import fetch from "isomorphic-fetch";

function useFetch(urls, parsers = []) {
  const INIT = [...Array(urls.length).keys()].map(_ => []);
  const [res, setRes] = useState(INIT);
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    Promise.all(urls.map(url => fetch(url).then(res => res.text())))
      .then(res => {
        const result = res.map((r, i) => {
          if (parsers[i]) return parsers[i](r);
        });
        setRes(result);
        setFetching(false);
      })
      .catch(err => console.log("fetch failed", err));
  }, []);

  return { res, fetching };
}

export default useFetch;
